import React, { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { getSessionUser } from './common-utils'

interface ProtectedRouteProps {
  children: ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const auth = getSessionUser()
  const token = auth?.token
  const location = useLocation()

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
